const getIntervalObject = (startDate, endDate) => {
  const hours = 0, minutes = 0, seconds =0, milliseconds = 0;
  return {
    start: new Date(new Date(startDate).setHours(hours, minutes, seconds, milliseconds)),
    end: new Date(new Date(endDate).setHours(hours, minutes, seconds, milliseconds)),
  };
}

export default getIntervalObject;